import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroImage from '../icons/ecom.jpg';
import TesterBudNavbar from '../../subComponent/TesterBudNavBar';
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  FormControl,
  Badge,
  Navbar,

  Offcanvas,
  ListGroup,
} from 'react-bootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BsCartFill } from 'react-icons/bs';
import Confetti from 'react-confetti';
import { motion, AnimatePresence } from 'framer-motion';

import laptopImage from './ecommerceProduct/laptopPro.jpg';
import mouseImage from './ecommerceProduct/wirelessMouse.jpg';
import keyboardImage from './ecommerceProduct/KeyboardRBG.jpg';
import headphonesImage from './ecommerceProduct/headphones.jpg';
import ssdImage from './ecommerceProduct/ssd.jpg';
import coke from './ecommerceProduct/coke.png';
import drinks from './ecommerceProduct/drinks.png';
import beautyProduct from './ecommerceProduct/DropictsBeauty-Product.png';
import earphone from './ecommerceProduct/earphone.png';
import goldZipperBag from './ecommerceProduct/golezipperBag.png';
import iphone14 from './ecommerceProduct/iphone14.png';
import LadiesPurse from './ecommerceProduct/LadiesPurse.png';
import ladiesShoes from './ecommerceProduct/ladiesShoes.png';
import QPhone from './ecommerceProduct/QPhone.png';
import QPhone128GB from './ecommerceProduct/Qphone128GB.jpg';
import RosemaryOil from './ecommerceProduct/RosemaryOil.png';
import sampoo from './ecommerceProduct/sampoo.png';
import wireless from './ecommerceProduct/wireless.png';
import wirelessEarbud from './ecommerceProduct/wirelessEarbud.png';
import monitorImage from './ecommerceProduct/monitor.jpg';

const productData = [
  { id: 1, name: 'Laptop Pro', price: 1200, image: laptopImage, quantity: 1 },
  { id: 2, name: 'Wireless Mouse', price: 25, image: mouseImage, quantity: 1 },
  { id: 3, name: 'Keyboard RGB', price: 80, image: keyboardImage, quantity: 1 },
  { id: 4, name: 'Headphones Noise Cancelling', price: 150, image: headphonesImage, quantity: 1 },
  { id: 5, name: 'External SSD 1TB', price: 180, image: ssdImage, quantity: 1 },
  { id: 6, name: 'Monitor 4K', price: 350, image: monitorImage, quantity: 1 },
  { id: 7, name: 'Coca Cola 250ml', price: 1, image: coke, quantity: 1 },
  { id: 8, name: 'Mango Drink', price: 2, image: drinks, quantity: 1 },
  { id: 9, name: 'Beauty Product', price: 30, image: beautyProduct, quantity: 1 },
  { id: 10, name: 'Premium Earphone', price: 75, image: earphone, quantity: 1 },
  { id: 11, name: 'Gold Zipper Bag', price: 90, image: goldZipperBag, quantity: 1 },
  { id: 12, name: 'Iphone 14 pro', price: 1000, image: iphone14, quantity: 1 },
  { id: 13, name: 'Premium Ladies Purse', price: 50, image: LadiesPurse, quantity: 1 },
  { id: 14, name: 'Ladies Shoes', price: 60, image: ladiesShoes, quantity: 1 },
  { id: 15, name: 'QPhone', price: 200, image: QPhone, quantity: 1 },
  { id: 16, name: 'QPhone 128GB', price: 250, image: QPhone128GB, quantity: 1 },
  { id: 17, name: 'Rosemary Oil', price: 15, image: RosemaryOil, quantity: 1 },
  { id: 18, name: 'Premium Sampoo', price: 20, image: sampoo, quantity: 1 },
  { id: 19, name: 'Wireless EarPhone', price: 110, image: wireless, quantity: 1 },
  { id: 20, name: 'wireless Earbud', price: 130, image: wirelessEarbud, quantity: 1 },
];

const AutomatingEcommerceFlows = () => {
  const [products, setProducts] = useState(productData);
  const [cart, setCart] = useState([]);
  
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
  });
  const [showPayment, setShowPayment] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [address, setAddress] = useState({
    name: '',
    street: '',
    city: '',
    state: '',
    zip: '',
  });
  
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        const width = container.clientWidth;
        const height = container.clientHeight;
        setDimensions({ width, height });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);


  const handleCloseOffcanvas = () => setShowOffcanvas(false);
  const handleShowOffcanvas = () => setShowOffcanvas(true);

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    const results = productData.filter((product) =>
      product.name.toLowerCase().includes(term.toLowerCase())
    );
    setSearchResults(results);
  };

  const handleAddToCart = (product) => {
    const existingProduct = cart.find((item) => item.id === product.id);
    if (existingProduct) {
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + product.quantity }
            : item
        )
      );
    } else {
      setCart([...cart, { ...product }]);
    }
  };

  const handleQuantityChange = (id, newQuantity) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, quantity: newQuantity } : product
      )
    );
  };

  const handleRemoveFromCart = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };

  const handlePaymentChange = (e) => {
    setPaymentDetails({ ...paymentDetails, [e.target.name]: e.target.value });
  };

  const validatePayment = () => {
    let isValid = true;
    const newErrors = {};

    if (!paymentDetails.cardNumber) {
      newErrors.cardNumber = 'Please enter card number.';
      isValid = false;
    }

    if (!paymentDetails.expiryDate) {
      newErrors.expiryDate = 'Please enter expiry date.';
      isValid = false;
    }

    if (!paymentDetails.cvv) {
      newErrors.cvv = 'Please enter CVV.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleProceedToBuy = () => {
    if (cart.length > 0) {
      setShowOffcanvas(false);
      setShowAddressForm(true);
    }
  };

  const handleBuy = () => {
    if (validatePayment()) {
      setOrderSuccess(cart);
      setCart([]);
      setShowPayment(false);
      setPaymentDetails({ cardNumber: '', expiryDate: '', cvv: '' });
      setErrors({});
      
      
    }
  };

  const handleAddressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleSaveAddress = () => {
    if (!address.name || !address.street || !address.city || !address.state || !address.zip) {
      alert('Please fill in all address fields.');
      return;
    }
    setShowAddressForm(false);
    setShowPayment(true);
  };

  const totalItemsInCart = cart.reduce((total, item) => total + item.quantity, 0);
  const cartTotal = cart.reduce((total, item) => total + item.price * item.quantity, 0);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    exit: { opacity: 0, y: -50, transition: { duration: 0.2 } },
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>Dummy E-commerce | TesterBud</title>
        <meta
          name="description"
          content="Practice automating online shopping scenarios."
        />
      </Helmet>
      
      <Container fluid className="hero-section bg-primary text-white py-4" style={{ position: 'relative', overflow: 'hidden' }}>
        <Row className="align-items-center justify-content-center">

          <Col md={6} className="text-center text-md-start">
            <h1 className="display-4 fw-bold mb-3">TesterBud: Dummy E-commerce Application </h1>

            <p className="lead mb-4">
              Practice automating shopping cart functionalities, order placement, and product browsing on a realistic demo e-commerce site. 🚀
            </p>


          </Col>
          <Col md={5} className="d-none d-md-block text-center">
            {/* Replace with your actual hero image component or import */}
            <div style={{ width: '50%', height: '50%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
              <div
                style={{
                  width: '50%', // Adjust the size of the circular area
                  height: '50%', // Ensure width and height are equal for a perfect circle
                  borderRadius: '70%', // This creates the circular shape
                  overflow: 'auto', // Clips the image to the circle
                  marginTop: '-4%',
                  marginRight: '10%',
                  marginBottom: '-4%',
                }}
              >
                <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain', // Or 'cover' depending on desired behavior
                }} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <TesterBudNavbar/>
      <div ref={containerRef} style={{ position: 'relative', alignContent: 'left' }}>

        <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
          <Container>
            <Navbar.Brand as={Link} to="/" className="fw-bold me-3">
              TesterBud: Premium Ecommerce
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
              <Form className="w-100 mx-auto" style={{ maxWidth: '600px' }}>
                <InputGroup>
                  <FormControl
                    type="search"
                    placeholder="Search for awesome products..."
                    aria-label="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{
                      padding: '0.75rem 1rem',
                      fontSize: '1.1rem',
                      borderRadius: '0.5rem',
                    }}
                  />
                </InputGroup>
              </Form>
            </Navbar.Collapse>

            {/* Cart on the far right */}
            <div className="d-flex align-items-center ms-auto">
              <Button
                variant="outline-light"
                className="position-relative"
                onClick={handleShowOffcanvas}
              >
                <BsCartFill size={20} />
                {totalItemsInCart > 0 && (
                  <Badge pill bg="danger" className="position-absolute top-0 start-100 translate-middle">
                    {totalItemsInCart}
                  </Badge>
                )}
              </Button>
            </div>
          </Container>
        </Navbar>

        <Container className="mt-4">
          {searchTerm && searchResults.length > 0 ? (
            <div>
              <h2>Search Results for "{searchTerm}"</h2>
              <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                {searchResults.map((product) => (
                  <Col key={product.id}>
                    <Card className="h-100 shadow-sm">
                      <Card.Img
                        variant="top"
                        src={product.image}
                        alt={product.name}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <Card.Body className="d-flex flex-column">
                        <Card.Title className="mb-2">{product.name}</Card.Title>
                        <Card.Subtitle className="mb-3 text-muted">
                          Price: ${product.price}
                        </Card.Subtitle>
                        <div className="mt-auto">
                          <Form.Group className="mb-2 d-flex align-items-center">
                            <Form.Label htmlFor={`quantity-${product.id}`} className="me-2">
                              Qty:
                            </Form.Label>
                            <Form.Control
                              id={`quantity-${product.id}`}
                              type="number"
                              value={product.quantity}
                              onChange={(e) =>
                                handleQuantityChange(product.id, parseInt(e.target.value))
                              }
                              min="1"
                              className="w-auto"
                            />
                          </Form.Group>
                          <Button variant="primary" onClick={() => handleAddToCart(product)}>
                            Add to Cart
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <Row xs={1} sm={2} md={3} lg={4} className="g-4">
              {products.map((product) => (
                <Col key={product.id}>
                  <Card className="h-100 shadow-sm">
                    <Card.Img
                      variant="top"
                      src={product.image}
                      alt={product.name}
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="mb-2">{product.name}</Card.Title>
                      <Card.Subtitle className="mb-3 text-muted">
                        Price: ${product.price}
                      </Card.Subtitle>
                      <div className="mt-auto">
                        <Form.Group className="mb-2 d-flex align-items-center">
                          <Form.Label htmlFor={`quantity-${product.id}`} className="me-2">
                            Qty:
                          </Form.Label>
                          <Form.Control
                            id={`quantity-${product.id}`}
                            type="number"
                            value={product.quantity}
                            onChange={(e) =>
                              handleQuantityChange(product.id, parseInt(e.target.value))
                            }
                            min="1"
                            className="w-auto"
                          />
                        </Form.Group>
                        <Button variant="primary" onClick={() => handleAddToCart(product)}>
                          Add to Cart
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}

          <Offcanvas show={showOffcanvas} onHide={handleCloseOffcanvas} placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Your Cart</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {cart.length === 0 ? (
                <p>Your cart is empty.</p>
              ) : (
                <ListGroup variant="flush" className="mb-3">
                  {cart.map((item) => (
                    <ListGroup.Item key={item.id} className="d-flex justify-content-between align-items-center">
                      <div>
                        {item.name} - ${item.price} x {item.quantity}
                      </div>
                      <Button variant="outline-danger" size="sm" onClick={() => handleRemoveFromCart(item.id)}>
                        Remove
                      </Button>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
              <div className="fw-bold">Total: ${cartTotal.toFixed(2)}</div>
              <div className="mt-3">
                <Button variant="success" onClick={handleProceedToBuy} disabled={cart.length === 0}>
                  Proceed to Buy
                </Button>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          <AnimatePresence>
            {showAddressForm && (
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                style={{
                  position: 'fixed',
                  top: '0',
                  left: '0',
                  width: '100vw',
                  height: '100vh',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  backgroundColor: 'rgba(0, 0, 0, 0.2)', // optional: dim background
                }}
              >
                <div
                  style={{
                    width: '95%',
                    maxWidth: '800px',
                    backgroundColor: '#f5f5dc',
                    borderRadius: '10px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                  }}
                >
                  <Card style={{ backgroundColor: 'transparent', border: 'none' }}>
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start mb-4">
                        <h2 className="m-0">Shipping Address</h2>
                        <Button variant="close" size="sm" onClick={() => setShowAddressForm(false)} />
                      </div>
                      <Form>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Label>Full Name:</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={address.name}
                            onChange={handleAddressChange}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStreet">
                          <Form.Label>Street Address:</Form.Label>
                          <Form.Control
                            type="text"
                            name="street"
                            value={address.street}
                            onChange={handleAddressChange}
                          />
                        </Form.Group>
                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="formCity">
                            <Form.Label>City:</Form.Label>
                            <Form.Control
                              type="text"
                              name="city"
                              value={address.city}
                              onChange={handleAddressChange}
                            />
                          </Form.Group>
                          <Form.Group as={Col} controlId="formState">
                            <Form.Label>State:</Form.Label>
                            <Form.Control
                              type="text"
                              name="state"
                              value={address.state}
                              onChange={handleAddressChange}
                            />
                          </Form.Group>
                          <Form.Group as={Col} controlId="formZip">
                            <Form.Label>ZIP Code:</Form.Label>
                            <Form.Control
                              type="text"
                              name="zip"
                              value={address.zip}
                              onChange={handleAddressChange}
                            />
                          </Form.Group>
                        </Row>
                        <Button variant="primary" onClick={handleSaveAddress}>
                          Save Address & Continue to Payment
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </div>
              </motion.div>
            )}
          </AnimatePresence>


          <AnimatePresence>
            {showPayment && (
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                style={{
                  position: 'fixed',
                  top: '0',
                  left: '0',
                  width: '100vw',
                  height: '100vh',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  backgroundColor: 'rgba(0, 0, 0, 0.2)', // Optional: dim background
                }}
              >
                <div
                  style={{
                    width: '95%',
                    maxWidth: '800px',
                    backgroundColor: '#f5f5dc', // Beige background
                    borderRadius: '10px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                  }}
                >
                  <Card style={{ backgroundColor: 'transparent', border: 'none' }}>
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start mb-4">
                        <h2 className="m-0">Payment Details</h2>
                        <Button variant="close" size="sm" onClick={() => setShowPayment(false)} />
                      </div>
                      <Form>
                        <Form.Group className="mb-3" controlId="formCardNumber">
                          <Form.Label>Card Number:</Form.Label>
                          <Form.Control
                            type="text"
                            name="cardNumber"
                            value={paymentDetails.cardNumber}
                            onChange={handlePaymentChange}
                          />
                          {errors.cardNumber && <Form.Text className="text-danger">{errors.cardNumber}</Form.Text>}
                        </Form.Group>

                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="formExpiryDate">
                            <Form.Label>Expiry Date:</Form.Label>
                            <Form.Control
                              type="text"
                              name="expiryDate"
                              value={paymentDetails.expiryDate}
                              onChange={handlePaymentChange}
                              placeholder="MM/YY"
                            />
                            {errors.expiryDate && <Form.Text className="text-danger">{errors.expiryDate}</Form.Text>}
                          </Form.Group>

                          <Form.Group as={Col} controlId="formCVV">
                            <Form.Label>CVV:</Form.Label>
                            <Form.Control
                              type="text"
                              name="cvv"
                              value={paymentDetails.cvv}
                              onChange={handlePaymentChange}
                            />
                            {errors.cvv && <Form.Text className="text-danger">{errors.cvv}</Form.Text>}
                          </Form.Group>
                        </Row>

                        <Button variant="primary" onClick={handleBuy}>
                          Buy Now
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </div>
              </motion.div>
            )}
          </AnimatePresence>


          <AnimatePresence>
            {orderSuccess && (
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                style={{
                  position: 'fixed',
                  top: '0',
                  left: '0',
                  width: '100vw',
                  height: '100vh',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  backgroundColor: 'rgba(0, 0, 0, 0.2)', // Optional: Dim background
                }}
              >
                <div
                  style={{
                    width: '95%',
                    maxWidth: '800px',
                    backgroundColor: '#f5f5dc',
                    borderRadius: '10px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                    position: 'relative',
                  }}
                >
                  {/* 🎉 Confetti animation */}
                  <Confetti
                    width={dimensions.width}
                    height={dimensions.height}
                    recycle={false}
                    numberOfPieces={200}
                    isFestive={true}
                  />

                  <Card className="text-center" style={{ backgroundColor: 'transparent', border: 'none' }}>
                    <Card.Header>
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="m-0">Order Successful!</h2>
                        <Link to="/">
                          <Button variant="close" size="sm" />
                        </Link>
                      </div>
                    </Card.Header>

                    <Card.Body>
                      <p>Woohoo!! Successfully purchased</p>

                      <ListGroup className="mt-3">
                        {orderSuccess.map((item) => (
                          <ListGroup.Item key={item.id} className="d-flex justify-content-between align-items-center">
                            <div>
                              {item.name} - ${item.price} x {item.quantity}
                            </div>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>

                      <Link to="/">
                        <Button variant="primary" className="mt-3">
                          Done
                        </Button>
                      </Link>
                    </Card.Body>
                  </Card>
                </div>
              </motion.div>
            )}
          </AnimatePresence>


          <div className="mt-5 text-center">
            <Link to="/" className="btn btn-outline-secondary">
              Back To Home Page ➡️
            </Link>
          </div>
        </Container>
      </div>
      <footer className="bg-dark text-light text-center py-4 mt-auto">
              <Container>
                <p className="mb-1">Ready to start automating? Explore, practice, and master!</p>
                <small>© 2025 TesterBud | Built for learners by learners 🚀</small>
              </Container>
            </footer>
    </HelmetProvider>
  );
};

export default AutomatingEcommerceFlows;

